// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TotalItems_wrapper__2t58a","countStart":"TotalItems_countStart__2qCFD","countEnd":"TotalItems_countEnd__2Km00","countTotal":"TotalItems_countTotal__1k02R"};